// import React from 'react';
// import HeroSection from './components/HeroSection';
// import BenefitsSection from './components/BenefitsSection';
// import TrustedSources from './components/TrustedSources';
// import CTASection from './components/CTASection';
// import Footer from './components/Footer';
// import './App.css';
// import HowSection from './components/HowSection';

// function App() {
//   return (
//     <div className="app-container">
//       <HeroSection />
//       <BenefitsSection />
//       <TrustedSources />
//       <CTASection />
//       <Footer />
//     </div>
//   );
// }

// export default App;




import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import TrustedSources from './components/TrustedSources';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import StreetAnalysis from './pages/demo2analysis';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import Header from './components/Header';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ContactPage from './pages/ContactPage';
import PricingSection from './components/PricingSection';
import ProtectedRoute from './components/protectedRoute';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('buyers');

  return (
    <AuthProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={
            <div className="app-container">
              <HeroSection />
              <BenefitsSection  
                activeTab={activeTab} 
                setActiveTab={setActiveTab} 
              />
              <TrustedSources />
              
              {/* Conditionally show these sections */}
              {/* {activeTab === 'agents' && ( */}
                <>
                  <PricingSection />
                  <CTASection />
                </>
              {/* )} */}
              
            </div>
          } />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          <Route path="/analysis" element={
            <ProtectedRoute>
              <StreetAnalysis />
             </ProtectedRoute>
          } />
           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />

      </Router>
    </AuthProvider>
  );
}

export default App;